export enum NavigationItemType {
  DEFAULT = 'default',
  OVERVIEW = 'overview',
}
